(ns ycweb.app.website.registry.edit
  (:require
   #?@(:cljs
       [[ajax.core :as ajax]])
   [rum.core :as rum]
   [ycweb.app.website.registry.common :as awr.cmn]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.forms :as forms]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc registry-created < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        screen-params (cmn/screen-params app-atom)
        reg-uuid
        (or
          (str (:uuid screen-params))
          (cmn/curact process-atom :uuid))]
    [:<>
     [:div
      {:class (yuc/bem :yc-page-content [:standard])}
      [:div
       {:class (yuc/bem :yc-section [:large])}
       [:div.u-max-width-640.u-block-center
        (headings/heading "Thank you. You're all set up." {:type :h1 :size :large})
        (headings/heading "A few important things to remember:" {:type :h4 :size :tiny})
        [:ol.yc-list
         [:li
          "Add products from a variety of price points to suit all your guests’ pockets."]
         [:li
          "Keep adding items to your registry, especially as you approach your wedding day. You don’t want your guests to run out of choices."]
         [:li
          "If a product on your registry becomes unavailable before it has been bought, we will remove the item and communicate that with you, so that you can replace it if you want to."]
         [:li
          "If a product on your registry becomes unavailable after it has been bought, our Customer Support team will contact you when you close the registry, and you can decide how to proceed at that stage (exchanging and swapping the gifts)."]
         [:li
          "Remember, when you do close your registry after your big day, you can swap and exchange items before it has been delivered to make sure you get exactly what you want."]]
        [:form.button-wrapper
         {:action "" :method "post"}
         [:input {:type "hidden" :name "accepted" :value "1"}]
         [:input {:type "hidden" :name "action" :value "accept"}]
         (buttons/button-web "Continue to Registry"
           {:on-click
            #(do
               #?(:cljs (.scrollTo js/window 0 0))
               (comms/ajax-post :web.registry/accept-agreement {:registry/uuid reg-uuid}))
            :type :button
            :style :primary
            :size :default
            :icon :arrow-right
            :icon-placement :right})]]
       (toaster/loading-overlay app-atom :web.registry/edit)]]]))

(defmethod comms/receive :web.registry/accept-agreement [app-atom {:keys [success agreement-signed?]}]
  (cond
    success
    (swap! (cmn/process-cursor app-atom) assoc-in [:registry :registry/agreement-signed?] agreement-signed?)

    :else
    (toaster/open-toast app-atom :error "Could not accept agreement" {})))

(defmethod grid/action :web.registry/edit.edit-details [app-atom config _]
  (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})
  (comms/ajax-post :web.registry/edit.edit-details config))

(defmethod comms/receive :web.registry/edit.edit-details [app-atom {:keys [success] :as edit-details-response}]
  (toaster/close-toast app-atom)
  (cond
    success
    (do
      (toaster/open-toast app-atom :success
        "Your details have been successfully updated."
        {:closetime 2000})
      (swap! (cmn/process-cursor app-atom) assoc :edit-details? false))

    :else
    (do
      (toaster/open-toast app-atom :error "Could not save preference" {:closetime 2000})
      (swap! (rum/cursor-in (cmn/process-cursor app-atom) [:registry])
        assoc
        (if (= (:tracking/type edit-details-response) :email)
          :registry/email-tracking?
          :registry/dashboard-tracking?)
        (:tracking/active edit-details-response)))))

(rum/defcs registry-details-form < rum/reactive cmn/cursors (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        registry-atom (rum/cursor-in process-atom [:registry])
        registry (rum/react registry-atom)
        node-atom (::node-atom local-atom)]
    [:div
     {:class (yuc/bem :yc-section [:standard])}
     [:form.u-max-width-480.u-block-center.js-manage-form
      {:ref (fn [node] (reset! node-atom node))}
      (headings/heading "Your details"
        {:type :h3
         :size :tiny})
      (forms/split-input-field
        ["First name:" "e.g. Jane" (rum/cursor-in registry-atom [:item-line/user :user/first-name])
         {:type :user :id :firstname :name :firstname}]
        ["Last name:" "e.g. Smith" (rum/cursor-in registry-atom [:item-line/user :user/last-name])
         {:type :user :id :lastname :name :lastname}])
      [:div.form-field
       (forms/input "Your contact number:" "083 000 0000"
         (rum/cursor-in registry-atom [:registry/client-order :client-order/contact-number])
         {:type :tel
          :id "number"
          :has-icon true})]
      [:div.form-field
       (datepicker/datepicker app-atom "Wedding date:" "Wedding date"
         [:web.registry :registry :registry/close-date]
         {:datatype :datedmy})]
      [:div.form-field
       [:label.form-label
        {:id "nearestcity" :for "nearestcity"}
        "Your nearest city:"]
       [:div.select-wrapper
        (forms/select-raw
          (rum/cursor registry-atom :registry/nearest-city)
          [{:value "" :text "- Please select -"}
           {:value "Bloemfontein" :text "Bloemfontein"}
           {:value "Cape Town" :text "Cape Town"}
           {:value "Durban" :text "Durban"}
           {:value "East London" :text "East London"}
           {:value "Johannesburg" :text "Johannesburg"}
           {:value "Pietermaritzburg" :text "Pietermaritzburg"}
           {:value "Port Elizabeth" :text "Port Elizabeth"}
           {:value "Pretoria" :text "Pretoria"}
           {:value "Other City or Town" :text "Other City or Town"}])]]
      (headings/heading "Your partner's details"
        {:type :h3
         :size :tiny})
      (forms/split-input-field
        ["Partner's first name:" "e.g. John" (rum/cursor-in registry-atom [:registry/partner :partner/first-name])
         {:type :user :id :pfirstname :name :pfirstname}]
        ["Partner's last name:" "e.g. Taylor" (rum/cursor-in registry-atom [:registry/partner :partner/last-name])
         {:type :user :id :plastname :name :plastname}])
      [:div.form-field
       (forms/input "Partner's email address:" "e.g. john.taylor@domain.com"
         (rum/cursor-in registry-atom [:registry/partner :partner/email])
         {:type :email
          :hide-email-helpers true
          :required? true
          :has-icon true})]
      [:div.form-field
       (forms/input "Partner's contact number:" "081 000 0000"
         (rum/cursor-in registry-atom [:registry/partner :partner/contact-number])
         {:type :tel
          :required? true
          :has-icon true})]
      [:div.form-control
       (buttons/button-web "Update Details"
         (merge
           (urlstate/href-on-click
             (forms/form-validate node-atom
               #(grid/dispatch-action app-atom :web.registry/edit.edit-details
                  {:user/first-name (get-in registry [:item-line/user :user/first-name])
                   :user/last-name (get-in registry [:item-line/user :user/last-name])
                   :user/contact-number (get-in registry [:registry/client-order :client-order/contact-number])
                   :registry/close-date (get-in registry [:registry/close-date])
                   :registry/nearest-city (get-in registry [:registry/nearest-city])
                   :registry/uuid (get-in registry [:ent/uuid])
                   :partner/first-name (get-in registry [:registry/partner :partner/first-name])
                   :partner/last-name (get-in registry [:registry/partner :partner/last-name])
                   :partner/email (get-in registry [:registry/partner :partner/email])
                   :partner/contact-number (get-in registry [:registry/partner :partner/contact-number])})))
           {:style :primary
            :size :default}))]]]))

(rum/defc payment-summary < rum/reactive [app-atom registry]
  (let [{:registry/keys [payment-total pending-payment-total client-order]} registry
        {:client-order/keys [has-vouchers?]} client-order]
    [:div.yc-section.yc-section--large
     [:div.cta-block.u-block-center.u-max-width-480
      (headings/heading [:span [:b "Paid for by Guests: "] (str "R" (yuc/currency-format payment-total))]
        {:center true
         :subtext (when has-vouchers? "(Including Gift Vouchers)")
         :type :h3
         :size :tiny})
      (when (and pending-payment-total (pos? pending-payment-total))
        [:p.yc-paragraph.yc-paragraph--small.u-text-center
         (str "Total payments pending: " "R" (yuc/currency-format pending-payment-total))
         [:br]
         "(Guests have ordered, but not paid yet.)"])

      [:div.flex-grid-group
       [:div {:class (yuc/bem :flex-grid-block [:s-1-2])}
        [:div.flex-grid-content
         (buttons/button-web "Close Registry"
           (merge
             (urlstate/href-on-click
               #(grid/open-modal app-atom :web.registry/close-registry-modal
                  {:config
                   {:title "Close Registry"
                    :registry/uuid (:ent/uuid registry)}}))
             {:type :button
              :style :dark
              :full true
              :size :default}))]]]]]))

(defmethod grid/action :web.registry/edit.remove-item [app-atom config _]
  (toaster/open-toast app-atom :processing "Removing item" {})
  (comms/ajax-post :web.registry/edit.remove-item config))

(defmethod comms/receive :web.registry/edit.remove-item
  [app-atom
   {:keys [success]
    :remove/keys [variation-id]}]
  (toaster/close-toast app-atom)
  (let [item-atom (rum/cursor-in (cmn/process-cursor app-atom) [:registry :registry/client-order :client-order/items variation-id])]
    (cond
      success
      (do
        (toaster/open-toast app-atom :success "Item removed" {:closetime 4000})
        (swap! item-atom
          (fn [o]
            (-> o
              (update :registry-item/needed-qty #(max 0 (dec %)))
              (update :registry-item/available-qty #(max 0 (dec %)))))))

      :else
      (toaster/open-toast app-atom :error "Item not removed" {:closetime 4000}))))

(defn add-to-cart [app-atom selected-item-atom]
  #?(:cljs
     (let [process-atom (cmn/process-cursor app-atom)
           {:registry/keys [can-edit?]} (cmn/curact process-atom [:registry])]
       (ajax/GET "/cart.htm"
         {:params
          {:action "addtocart"
           :contentid (:item-line/product-id @selected-item-atom)
           (str "qty[" (:item-line/variation-id @selected-item-atom) "]") 1
           :overrideincludes "ajax"
           :whichButtonClicked "registry"}
          :handler
          (fn [response]
            (do
              (toaster/open-toast app-atom :success "Item added" {})
              (swap! selected-item-atom
                (fn [o]
                  (-> o
                    (update :registry-item/needed-qty (fnil inc 0))
                    (update :registry-item/available-qty (fnil inc 0)))))))

          :error-handler
          (fn [response]
            (toaster/open-toast app-atom :error "Item could not be added" {}))}))))

(defmethod grid/action :web.registry/edit.add-item [app-atom config _]
  (toaster/open-toast app-atom :processing "Adding item" {})
  (comms/ajax-post :web.registry/edit.add-item config))

(defmethod comms/receive :web.registry/edit.add-item
  [app-atom
   {:keys [success]
    :add/keys [variation-id]}]
  (let [process-atom (cmn/process-cursor app-atom)
        item-atom (rum/cursor-in process-atom [:registry :registry/client-order :client-order/items variation-id])
        from-product-page? (= :add-product-item (cmn/curact process-atom :registry-action))]
    (cond
      success
      (do
        (toaster/close-toast app-atom)
        (toaster/close-overlay app-atom :web.product/loading)
        (if from-product-page?
          (do
            (swap! process-atom dissoc :registry-action :pending-registry-variation-id)
            (grid/message-modal app-atom
              {:title "Registry"
               :text "This item has been added to your registry."
               :type :success
               :confirm-text "OK"}))
          (toaster/open-toast app-atom :success "Item added" {:closetime 4000}))
        (swap! item-atom
          (fn [o]
            (-> o
              (update :registry-item/needed-qty (fnil inc 0))
              (update :registry-item/available-qty (fnil inc 0))))))

      :else
      (add-to-cart app-atom item-atom))))

(defmethod grid/action :web.registry/edit.update-favourite [app-atom {:registry/keys [registry-item] :as config} _]
  (toaster/open-toast app-atom :processing (if (:registry-item/favourite? registry-item) "Saving favourite" "Removing favourite") {:closetime 4000})
  (comms/ajax-post :web.registry/edit.update-favourite config))

(defmethod comms/receive :web.registry/edit.update-favourite [app-atom {:favourite/keys [favourite? variation-id] :as favourite-response}]
  (let [item-atom (rum/cursor-in (cmn/process-cursor app-atom) [:registry :registry/client-order :client-order/items variation-id])]
    (toaster/close-toast app-atom)
    (toaster/open-toast app-atom :success (if favourite? "Favourite saved" "Favourite removed") {:closetime 4000})
    (swap! item-atom assoc :registry-item/favourite? favourite?)))

(defmethod grid/action :web.registry/upload-photo-modal [app-atom config _]
  (grid/open-modal app-atom :web.registry/upload-photo-modal {}))

(defmethod grid/action :web.registry/change-cover-modal [app-atom config _]
  (grid/open-modal app-atom :web.registry/change-cover-modal
    {:config
     {:title "Change Cover"}}))

(defmethod grid/action :web.registry/edit.edit-message [app-atom config _]
  (toaster/open-toast app-atom :processing "Updating greeting" {:closetime 10000})
  (comms/ajax-post :web.registry/edit.edit-message config))

(defmethod comms/receive :web.registry/edit.edit-message [app-atom {:keys [success]}]
  (toaster/close-toast app-atom)
  (let [process-atom (cmn/process-cursor app-atom)]
    (cond
      success
      (do
        (toaster/open-toast app-atom :success "Greeting updated" {:closetime 2000})
        (swap! process-atom assoc-in [:edit-greeting?] false))

      :else
      (toaster/open-toast app-atom :error "Failed to save greeting" {:closetime 2000}))))

(defmethod grid/action :web.registry/edit.edit-photo [app-atom config]
  (let [process-atom (cmn/process-cursor app-atom)
        registry-uuid (cmn/curact process-atom [:registry :ent/uuid])
        image-uuid (cmn/curact process-atom [:registry :ent/image :ent/uuid])]
    (toaster/open-toast app-atom :processing "Uploading image" {:closetime 10000})
    (comms/ajax-post :web.registry/edit.edit-photo
      {:ent/uuid registry-uuid
       :ent/image
       {:ent/uuid image-uuid
        :doc/data (:data config)}})))

(defmethod comms/receive :web.registry/edit.edit-photo [app-atom upload-photo-response]
  (let [public-id (get-in upload-photo-response [:registry :ent/image :doc/public-id])]
    (toaster/close-toast app-atom)
    (grid/close-modal app-atom)
    (swap! (cmn/process-cursor app-atom) assoc-in [:registry :ent/image :doc/public-id] public-id)))

(defmethod grid/action :web.registry/edit.edit-background [app-atom config _]
  (toaster/open-toast app-atom :processing "Updating background" {:closetime 10000})
  (comms/ajax-post :web.registry/edit.edit-background config))

(defmethod comms/receive :web.registry/edit.edit-background [app-atom {:keys [success] :as edit-background-response}]
  (toaster/close-toast app-atom)
  (let [registry-atom (rum/cursor-in (cmn/process-cursor app-atom) [:registry])]
    (cond
      success
      (do
        (toaster/open-toast app-atom :success "Background updated" {:closetime 2000})
        (swap! registry-atom assoc
          :registry/background-id (:background/id edit-background-response)
          :registry/colour-palette (:background/colour-palette edit-background-response)))

      :else
      (toaster/open-toast app-atom :error "Failed to update background" {:closetime 2000}))))

(rum/defc save-greeting < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        registry (cmn/curact process-atom [:registry])]
    [:<>
     [:div.u-block-center.u-max-width-720
      (forms/textarea ""
        (rum/cursor-in process-atom [:registry :registry/message])
        {:class "text-input text-area"
         :rows 8})]
     [:div
      {:class (yuc/bem :button-wrapper [:center])}
      (buttons/button-web "Save Greeting"
        {:on-click
         #(grid/dispatch-action app-atom :web.registry/edit.edit-message
            {:registry/message (cmn/curact process-atom [:registry :registry/message])
             :registry/uuid (:ent/uuid registry)})
         :style :secondary
         :size :default
         :icon :pencil})]]))

(defmethod grid/action :web.registry/edit.edit-greeting? [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc-in [:edit-greeting?] true)))

(rum/defc edit-greeting < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:registry/keys [message]} (cmn/curact process-atom [:registry])]
    [:<>
     [:p.yc-paragraph {:style {:white-space "pre-line"}} message]
     [:div
      {:class (yuc/bem :button-wrapper [:center])}
      (buttons/button-web "Edit Greeting"
        {:on-click #(grid/dispatch-action app-atom :web.registry/edit.edit-greeting? {:edit-greeting? true})
         :style :secondary
         :size :default
         :icon :pencil})]]))

;; -- REGISTRY MANAGE PAGES --
(rum/defc registry-manage < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [edit-greeting? edit-details?]} (rum/react process-atom)
        {:registry/keys [client-order show-tutorial?] :as registry} (cmn/curact process-atom [:registry])
        {:client-order/keys [items id]} client-order

        edit-mode? true

        screen-params (cmn/screen-params app-atom)
        reg-uuid
        (or
          (str (:uuid screen-params))
          (cmn/curact process-atom :uuid))]
    [:<>
     (awr.cmn/registry-banner app-atom registry edit-mode?)
     (awr.cmn/registry-manage-nav app-atom :edit-view registry process-atom)
     (when show-tutorial?
       (grid/open-modal app-atom :web.registry/welcome-modal
         {:config
          {:title "Welcome"
           :client-order/id id}}))
     [:div
      {:class (yuc/bem :section [:standard])}
      (feedback/feedback-raw :info {:title (str "Your registry link is yuppiechef.com/yc" id) :size :small :class "u-max-width-380"})]
     [:div
      {:class (yuc/bem :yc-section [:medium-underline])}
      [:div.yc-intro-text
       (cond
         edit-greeting?
         (save-greeting app-atom)

         :else
         (edit-greeting app-atom))]]

     [:div#js-manage-form-wrapper
      (when edit-details? (registry-details-form app-atom))]

     (awr.cmn/order-table app-atom edit-mode? items)
     (payment-summary app-atom registry)
     (toaster/loading-overlay app-atom :web.registry/edit)]))

(defmethod flow/render-screen :web.registry/edit [app-atom _]
  (let [process-atom (cmn/process-cursor app-atom)

        {:registry/keys [client-order agreement-signed?] :as registry}
        (cmn/curact process-atom [:registry])]

    (swap! app-atom assoc :registry/order-id (:client-order/id client-order))
    (awr.cmn/set-registry-session (:client-order/id client-order))
    (toaster/close-toast app-atom)
    (website/screen-wrapper app-atom
      (cond
        (not agreement-signed?)
        (registry-created app-atom)

        :else
        (registry-manage app-atom))
      {:pagetype :registry})))

(defmethod t/transition-open :web.registry/edit [app-atom _ e]
  (toaster/open-overlay app-atom :web.registry/edit)
  (comms/ajax-get :web.registry/edit {:uuid (:uuid e)}))

(defmethod comms/receive :web.registry/edit [app-atom {:keys [registry categories] :as response}]
  (let [client-order-items (:client-order/items (:registry/client-order registry))]
    (swap! (cmn/process-cursor app-atom) assoc
      :registry registry
      :categories
      {:categories categories
       :group-items-by-key (if (empty? client-order-items) "category" "purchased")}
      :edit-greeting? false
      :edit-details? false))
  (toaster/close-overlay app-atom :web.registry/edit))

(defmethod grid/action :web.registry/edit.tutorial-viewed [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        registry (cmn/curact process-atom :registry)
        registry-uuid (:ent/uuid registry)]
    (comms/ajax-post :web.registry/edit.tutorial-viewed {:registry/uuid (str registry-uuid)})))

(defmethod comms/receive :web.registry/edit.tutorial-viewed
  [app-atom
   {:keys [success]
    :registry/keys [show-tutorial?]}]

  (let [process-atom (cmn/process-cursor app-atom)]
    (when success
      (swap! process-atom assoc-in [:registry :registry/show-tutorial?] show-tutorial?))))

(defmethod grid/action :web.registry/edit.choose [app-atom config _]
  (toaster/open-toast app-atom :processing "Finding your registry" {:closetime 10000})
  (comms/ajax-get :web.registry/edit.choose {}))

(defmethod comms/receive :web.registry/edit.choose
  [app-atom
   {:keys [success]
    :choose/keys [multiple registries registry selected-registry]}]
  (toaster/close-toast app-atom)
  (toaster/close-overlay app-atom :web.product/loading)
  (let [registry-action (cmn/curact (cmn/process-cursor app-atom) :registry-action)]
    (cond
      (not success)
      (toaster/open-toast app-atom :error :msg {:closetime 2000})

      (and success multiple)
      (grid/open-modal app-atom :web.registry/choose-registry-modal
        {:config
         {:title "Choose Registry"
          :selected-registry selected-registry
          :registries registries}})

      (nil? registry)
      (grid/open-modal app-atom :web.registry/no-registry-modal)

      :else
      (grid/dispatch-action app-atom :web.registry/edit.selected {:registry registry :registry-action registry-action}))))

(defmethod grid/action :web.registry/edit.selected [app-atom config _]
  (cond
    (= (:registry-action config) :add-collection-item)
    (grid/dispatch-action app-atom :web.registry/collection.add-item (select-keys config [:registry]))

    (= (:registry-action config) :add-collection)
    (grid/dispatch-action app-atom :web.registry/collection.add (select-keys config [:registry]))

    (= (:registry-action config) :add-product-item)
    (let [variation-id (cmn/curact (cmn/process-cursor app-atom) :pending-registry-variation-id)
          registry-uuid (get-in config [:registry :ent/uuid])]
      (when (and variation-id registry-uuid)
        (grid/dispatch-action app-atom :web.registry/edit.add-item
          {:registry-item/variation-id variation-id
           :registry/uuid registry-uuid})))))